import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _60a55569 = () => interopDefault(import('../pages/401/index.vue' /* webpackChunkName: "pages/401/index" */))
const _1b91dc6d = () => interopDefault(import('../pages/forbidden/index.vue' /* webpackChunkName: "pages/forbidden/index" */))
const _54ecc8e7 = () => interopDefault(import('../pages/demo/dlocal/index.vue' /* webpackChunkName: "pages/demo/dlocal/index" */))
const _f267aefe = () => interopDefault(import('../pages/demo/dlocal2/index.vue' /* webpackChunkName: "pages/demo/dlocal2/index" */))
const _ff4653e0 = () => interopDefault(import('../pages/demo/gradient/index.vue' /* webpackChunkName: "pages/demo/gradient/index" */))
const _3832aa44 = () => interopDefault(import('../pages/demo/pay/index.vue' /* webpackChunkName: "pages/demo/pay/index" */))
const _64486988 = () => interopDefault(import('../pages/demo/rich/index.vue' /* webpackChunkName: "pages/demo/rich/index" */))
const _731b7d58 = () => interopDefault(import('../pages/sites/_sid/index.vue' /* webpackChunkName: "pages/sites/_sid/index" */))
const _377da190 = () => interopDefault(import('../pages/preview/_sid/_lang/_pageid/index.vue' /* webpackChunkName: "pages/preview/_sid/_lang/_pageid/index" */))
const _afcecb7a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/401",
    component: _60a55569,
    name: "401"
  }, {
    path: "/forbidden",
    component: _1b91dc6d,
    name: "forbidden"
  }, {
    path: "/demo/dlocal",
    component: _54ecc8e7,
    name: "demo-dlocal"
  }, {
    path: "/demo/dlocal2",
    component: _f267aefe,
    name: "demo-dlocal2"
  }, {
    path: "/demo/gradient",
    component: _ff4653e0,
    name: "demo-gradient"
  }, {
    path: "/demo/pay",
    component: _3832aa44,
    name: "demo-pay"
  }, {
    path: "/demo/rich",
    component: _64486988,
    name: "demo-rich"
  }, {
    path: "/sites/:sid",
    component: _731b7d58,
    name: "sites-sid"
  }, {
    path: "/preview/:sid?/:lang?/:pageid",
    component: _377da190,
    name: "preview-sid-lang-pageid"
  }, {
    path: "/",
    component: _afcecb7a,
    name: "index"
  }, {
    path: "/:lang/",
    component: _afcecb7a,
    props: true,
    name: "SiteLangIndexPage"
  }, {
    path: "/:lang/:pageid",
    component: _afcecb7a,
    props: true,
    name: "SiteLangPagePage"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
